import TermList from "../AdminTermList";

export default class AdminTermListNotificationChannel extends TermList {
  /**
   * @returns {string} The term type.
   */
  getType() {
    return "notification_channel";
  }
}
